import React from 'react';
import { connect } from 'react-redux';
import globalConstants from 'app/constants/global-constants';
import SidebarResoucesItem from './SidebarResoucesItem';
import Button from '../../components/Button/Button';
import Icon from './icon.svg';
import './sidebar.scss';
import bg from './bg.svg';
var bloomSections = [
    {
        title: 'Neo4j Bloom',
        items: [
            {
                text: 'Bloom Video Series',
                url: 'https://www.youtube.com/playlist?list=PL9Hl4pk2FsvWqH11v_WXVNIgb4iHjqHgs',
            },
            {
                text: 'Bloom Guide',
                url: 'https://neo4j.com/docs/bloom-user-guide/current/',
            },
        ],
    },
];
var sections = [
    {
        title: 'Get Help',
        items: [
            {
                text: 'Neo4j Community',
                url: 'https://community.neo4j.com/c/neo4j-graph-platform/10/?ref=sandbox',
            },
            {
                text: 'GraphAcademy (free online courses)',
                url: 'http://graphacademy.neo4j.com/',
            },
            {
                text: 'Developer Guides',
                url: 'https://neo4j.com/developer/get-started/',
            },
        ],
    },
];
function Sidebar(_a) {
    var runningSandboxes = _a.runningSandboxes;
    var handleAuraCtaClick = function () {
        return window.neo4jSandbox.tracking.event('SANDBOX_SIDEBAR_CLICK', {
            text: 'start aura free',
        });
    };
    var showBloomResources = runningSandboxes &&
        runningSandboxes.length > 0 &&
        runningSandboxes.filter(function (i) { return globalConstants.bloomUseCases.indexOf(i.usecase) > -1; }).length >
            0;
    var localStoragePersona = window.localStorage && window.localStorage.getItem('neo4j_persona');
    return (React.createElement("div", { className: "ml3" },
        showBloomResources && (React.createElement("div", { className: "mb4" },
            React.createElement(SidebarResoucesItem, { sections: bloomSections }))),
        React.createElement("div", { className: "mb4" },
            React.createElement(SidebarResoucesItem, { sections: sections })),
        // localStoragePersona !== 'data-scientist' &&
        (React.createElement("div", { className: "sidebar mb4", style: {
                // Using inline style as a workaround.
                // background: url("bg.svg") used in SCSS causes a css-loader failure
                backgroundImage: "url(".concat(bg, ")")
            } },
            React.createElement("div", { className: "px4 pt3 pb3" },
                React.createElement("img", { className: "sidebar-icon", src: Icon, alt: "", role: "presentation" }),
                React.createElement("h3", { className: "sidebar-header" }, "Master Neo4j with GraphAcademy"),
                React.createElement("p", { className: "sidebar-text" }, "Take your Neo4j skills to the next level with free, hands-on courses"),
                React.createElement("div", { className: "sidebar-button-wrap" },
                    React.createElement(Button, { href: "https://graphacademy.neo4j.com/?ref=sandbox", target: "_blank", className: "sidebar-button", size: "small", onClick: handleAuraCtaClick }, "Start Learning")))))));
}
var mapStateToProps = function (state) { return ({
    runningSandboxes: state.sandbox.items,
}); };
export default connect(mapStateToProps, null)(Sidebar);
